import {
    ADD_NEW_EQUIPMENT,
    FETCH_ALL_EQUIPMENTS,
    CALL_ALL_EQUIPMENTS,
    SINGLE_SELECT_EQUIPMENT,
    GET_FREE_EQUIPMENT
} from './actions';

export default function reducer(
    state = {
        showNewEquipment: false,
        fetchEquipments: true,
        allEquipments: [],
        allFreeEquipments: [],
        singleSelectEquipment: {}
    },
    action
) {
    switch (action.type) {
        case ADD_NEW_EQUIPMENT:
            return {
                ...state,
                showNewEquipment: action.payload.data,
            };
        case FETCH_ALL_EQUIPMENTS:
            return {
                ...state,
                allEquipments: action.payload.data,
            };
        case GET_FREE_EQUIPMENT:
            return {
                ...state,
                allFreeEquipments: action.payload.data,
            };
        case CALL_ALL_EQUIPMENTS:
            return {
                ...state,
                fetchEquipments: action.payload.data,
            };
        case SINGLE_SELECT_EQUIPMENT:
            return {
                ...state,
                singleSelectEquipment: action.payload.data,
            };
        default:
            return state;
    }
    // return state;
}
